export enum ProductChargingMode {
    Once = 'Once',
    PerPerson = 'PerPerson',
    PerPersonPerTimeUnit = 'PerPersonPerTimeUnit',
    PerTimeUnit = 'PerTimeUnit',
}
